import React, { useState, useEffect, useContext } from 'react';
import './bls-choose-campaigns.scss';
import { default as t } from '../../../utils/i18n';
import queryString from 'query-string';
import { UserContext } from '../../../context';
import InputGroup from 'rsuite/InputGroup';
import { DatePicker, DateRangePicker, Checkbox } from 'rsuite';
import { DashService } from '../../../services';
import { Table, Pagination } from 'rsuite';
import subMonths from 'date-fns/subMonths';

const BlsChooseCampaigns = props => {
  const { Column, HeaderCell, Cell } = Table;
  const location = queryString?.parse(window.location.search);
  const { user, setUser } = useContext(UserContext);
  const username = user?.username;
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const [accountsModalOverview, setAccountsModalOverview] = useState(false);
  const [selecetedLimit, setSelectedLimit] = useState(10);
  const [show, showstyle] = useState('');
  const [searchItem, setSearchItem] = useState('');
  const [campaignList, setCampaignList] = useState('');
  const [page, setPage] = useState(1);
  const [selectedCampaigns, setSelectedCAmpaigns] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  const { allowedRange, before } = DateRangePicker;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startDateDisable, setStartDateDisable] = useState(false);
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [dateRangeValue, setDateRangeValue] = useState(null);

  let date = new Date();
  let threeYearBeforedate = date.setMonth(date.getMonth() - 36);

  const handleBackClick = () => {
    document.body.style.overflow = 'auto';
    setTimeout(() => {
      props.handleModalBackClick(false);
    }, 1000);
    setAccountsModalOverview(!accountsModalOverview);
  };

  useEffect(() => {
    setAccountsModalOverview(true);
    onStartDateChange(new Date(subMonths(new Date(), 36)));
    onEndDateChange(new Date());
    props.totalRes.find(study => study?.cells?.find(cell => {
      if(cell?.selected && cell?.startDate) {
        onStartDateChange(new Date(cell?.startDate));
        onEndDateChange(new Date(cell?.endDate));
        setSelectedCAmpaigns([...cell?.selectedCampaigns]);
        getCampaigns(new Date(cell?.startDate), new Date(cell?.endDate), cell?.selectedCampaigns);
      }
    }))

  }, []);

  const onStartDateChange = val => {
    if (val && val !== null) {
      setStartDate(new Date(val));
      setEndDateDisable(false);
      setEndDate(null);
    } else {
      setStartDate(val);
      setEndDate(null);
      setDateRangeValue(null);
      setEndDateDisable(true);
    }
  };

  const onEndDateChange = val => {
    if (val && val !== null) {
      setEndDate(new Date(val));
      setDateRangeValue([new Date(startDate), new Date(val)]);
      let startDateCheck = startDate ? startDate : new Date(subMonths(new Date(), 36));
      getCampaigns(new Date(startDateCheck), new Date(val));
    } else {
      setEndDate(val);
      setDateRangeValue(null);
    }
  };

  const filterHandler = keyword => {
    if (!keyword.trim()) {
      showstyle('');
      setSearchItem('');
      setSelectedLimit(selecetedLimit)
      setPage(1);
      const syncedCampaignList = originalList.map(campaign => ({
        ...campaign,
        campaignChecked: selectedCampaigns.some(selected => selected.id === campaign.id),
      }));
  
      setCampaignList([...syncedCampaignList]);
      // setCampaignList([...originalList])
    } else {
      showstyle('show');
      setSearchItem(keyword);
      setPage(1);
      setSelectedLimit(selecetedLimit)
    }
    if(keyword?.trim() !== '') {
      let searchedResult = originalList.filter(function (obj) {
        return obj?.id?.includes(keyword) || obj?.name?.toLowerCase().includes(keyword);
    });
    const syncedSearchedResult = searchedResult.map(campaign => ({
      ...campaign,
      campaignChecked: selectedCampaigns.some(selected => selected.id === campaign.id),
    }));
    setCampaignList([...syncedSearchedResult]);
    // setCampaignList([...searchedResult]);
    }
  };

  const updateDateFormatApi = (val, isTable) => {
    const d = new Date(val);
    d.setUTCHours(0, 0, 0, 0);
    const yyyy = d.getFullYear();
    let mm = d.getMonth() + 1; // Months start at 0!
    let dd = d.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    return isTable ? dd + '-' + mm + '-' + yyyy : yyyy + '-' + mm + '-' + dd;
  };

  async function getCampaigns(stDate, edDate, selected) {
    let sDate = updateDateFormatApi(new Date(stDate));
    let eDate = updateDateFormatApi(new Date(edDate));
    if (sDate && eDate && user?.dropdowns?.adaccount?.value) {
      const query =
        'type=' +
        'completed' +
        '&adAccounts=' +
        user?.dropdowns?.adaccount?.value.toString() +
        '&startDate=' +
        sDate +
        '&endDate=' +
        eDate;
      try {
        const campaignsResponse = await DashService.getCampaignsList(
          userAccessToken,
          username,
          query
        );
        let response = await campaignsResponse.data?.data?.campaigns;
        response.forEach(campaign => {
          campaign.campaignChecked = false;
          campaign.dateRange = getDateRange(campaign.start_time, campaign.stop_time);
        });
        if(selected?.length) {
          selected.forEach(li => {
            response?.forEach(campaign =>  {
              if(li.id === campaign.id) {
                campaign.campaignChecked = true;
              }
            })
          })
        }
        setOriginalList([...response])
        setCampaignList([...response]);
        getData(response);
      } catch (error) {}
    }
  }

  const getDateRange = (startTime, stopTime) => {
    if (stopTime) {
      return updateDateFormatApi(startTime, true) + ' to ' + updateDateFormatApi(stopTime, true);
    } else {
      return updateDateFormatApi(startTime, true) + ' ' + 'onwards';
    }
  };

  const getWidth = (value = 6) => {
    return window.innerWidth / value;
  };

  const onChangeLimit = (limit) => {
    setPage(1);
    setSelectedLimit(limit);
    getData(campaignList, limit)
  };

  const onPageChange = page => {
    setPage(page);
  };

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <div style={{ lineHeight: '46px' }}>
        <Checkbox value={rowData} inline onChange={onChange} checked={rowData[dataKey]} />
      </div>
    </Cell>
  );

  // const handleCheck = (value, checked) => {
  //   campaignList.find(ac => ac.id === value.id).campaignChecked = checked;
  //   let selAccounts = [...selectedCampaigns];
  //   campaignList?.forEach((res, i) => {
  //     if (res?.campaignChecked) {
  //       selAccounts.push(res);
  //     }
  //   });
  //   setCampaignList([...campaignList]);
  //   setSelectedCAmpaigns([...selAccounts]);
  // };
  const handleCheck = (value, checked) => {
    // Update the persistent selected campaigns list
    let updatedSelectedCampaigns = [...selectedCampaigns];
    if (checked) {
      // Add the checked campaign to selectedCampaigns if not already present
      if (!updatedSelectedCampaigns.find(campaign => campaign.id === value.id)) {
        updatedSelectedCampaigns.push(value);
      }
    } else {
      // Remove the unchecked campaign from selectedCampaigns
      updatedSelectedCampaigns = updatedSelectedCampaigns.filter(campaign => campaign.id !== value.id);
    }
  
    // Update the campaign list to reflect the current checked state
    const updatedCampaignList = campaignList.map(campaign => {
      if (campaign.id === value.id) {
        return { ...campaign, campaignChecked: checked };
      }
      return campaign;
    });
  
    setCampaignList(updatedCampaignList);
    setSelectedCAmpaigns(updatedSelectedCampaigns);
  };

  const getData = response => {
    let data = [...campaignList]?.filter((v, i) => {
      const start = selecetedLimit * (page - 1);
      const end = start + selecetedLimit;
      return i >= start && i < end;
    });
    return data;
  };

  const onClose = () => {
    props.handleModalBackClick(false);
  };

  const onAdd = () => {
    props.handleModalBackClick(false, selectedCampaigns, startDate, endDate);
  };

  const CellDetails = ({rowData, dataKey, ...props}) => {
    return (
      <Cell {...props} >
         <div className='text_overflow' title={rowData[dataKey]}>{rowData[dataKey]}</div>
      </Cell>
    )
  }

  return (
    <>
      <div className={`attribute-detail-view-overlay ${accountsModalOverview ? 'show' : 'hide'}`}>
        <div className="attribute-detail-view bls">
          <div className="attribute-detail-view-buttongroup">
            <button className="return-insights" onClick={() => handleBackClick()}>
              <i className="eva  eva-arrow-ios-back-outline"></i>
              {t('user.buttonText.back')}
            </button>
          </div>
          <div className="import-campaign-cta">
            <div className="accounts_header">{t('bls.choose.campaigns.text')}</div>
          </div>
          <div className="campaign_choose">
            <div className="filter-section">
              <div className="left-section left_padding">
                <div className='width_30'>
                  <div className="ac_details_header">{t('bls.study.bm')}</div>
                  <div className="ac_details_val" title={user?.dropdowns?.businessManager?.label}>{user?.dropdowns?.businessManager?.label}</div>
                </div>
                <div className='width_30'>
                  <div className="ac_details_header">{t('bls.study.ad.account')}</div>
                  <div className="ac_details_val" title={user?.dropdowns?.adaccount?.label}>{user?.dropdowns?.adaccount?.label}</div>
                </div>
                <div className="bottom-section date_picker_width">
                  <InputGroup>
                    <DatePicker
                      id="start-date"
                      disabled={startDateDisable}
                      format="dd-MM-yyyy"
                      value={startDate}
                      onChange={e => onStartDateChange(e)}
                      disabledDate={allowedRange(new Date(threeYearBeforedate), new Date())}
                      placeholder={t('report.wrapper.start.date')}
                      oneTap
                    />
                    <InputGroup.Addon>to</InputGroup.Addon>
                    <DatePicker
                      id="end-date"
                      disabled={endDateDisable}
                      format={'dd-MM-yyyy'}
                      value={endDate}
                      onChange={e => onEndDateChange(e)}
                      disabledDate={before(startDate)}
                      placeholder={t('report.wrapper.end.date')}
                      oneTap
                    />
                  </InputGroup>
                </div>
              </div>
            </div>
          </div>
          <div className="search-section-container search_onboarded">
            <h3></h3>
            <div className="search-field search_onboarded_icon">
              <i className="eva eva-search-outline search-icon"></i>
              <input
                type="text"
                name="search"
                placeholder={t('admin.details.search')}
                onChange={e => filterHandler(e.target.value, e)}
                value={searchItem}
                autoComplete="off"
              />
              <button
                type="button"
                className={`clear-btn ${show}`}
                onClick={e => filterHandler('')}
              >
                <i className="eva eva-close-outline clear-icon"></i>
              </button>
            </div>
          </div>
          <div>
            <Table autoHeight data={getData()} bordered cellBordered className="admin-table">
              <Column width={getWidth(17)}>
                <HeaderCell>{t('bls.campaign.cell')}</HeaderCell>
                <CheckCell dataKey="campaignChecked" onChange={handleCheck} />
              </Column>

              <Column width={getWidth(4)}>
                <HeaderCell>{t('bls.campaign.id')}</HeaderCell>
                <CellDetails dataKey="id" />
              </Column>

              <Column width={getWidth(3)}>
                <HeaderCell>{t('define.stepper.table.campaignName')}</HeaderCell>
                <CellDetails dataKey="name" />
              </Column>

              <Column width={getWidth()}>
                <HeaderCell>{t('define.stepper.table.dateRange')}</HeaderCell>
                <CellDetails dataKey="dateRange" />
              </Column>
            </Table>
          </div>
          <div className="pagination-div">
            <span>{t('reports.per.page')}</span>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              layout={['-', 'limit', '|', 'pager']}
              total={campaignList?.length}
              limitOptions={[10, 15]}
              limit={selecetedLimit}
              activePage={page}
              onChangePage={page => {
                onPageChange(page);
              }}
              onChangeLimit={onChangeLimit}
            />
          </div>
          <div className="add-btn btn_alignment">
            <button className="step-back" onClick={onClose}>
              {t('admin.add.close')}
            </button>
            <button className="step-back step-add" onClick={onAdd}>
              {t('admin.adaccount.add')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlsChooseCampaigns;
